var $export = require('./_export')
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require('./_object-create')});


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/es6.object.create.js
// module id = 334
// module chunks = 3